import React, { Component } from "react";
import _ from "lodash";
import { Table } from "semantic-ui-react";
import Address from "./Address";
import getPersonName from "../common/Name";

class BusinessRecordDetail extends Component {
  componentDidMount() {}

  render() {
    const results = [];
    const { node } = this.props;
    if (node !== undefined && node !== null) {
      results.push(
        <Table.Row key={`Business_Record_Address_Row_${this.props.index}`}>
          <Table.Cell>Address:</Table.Cell>
          <Table.Cell>
            <Address
              key={`Business_Record_Address_${this.props.index}`}
              addressNode={node}
              {...this.props}
            />
          </Table.Cell>
          <Table.Cell>Officer:</Table.Cell>
          <Table.Cell>
            {getPersonName(
              _.get(node, "firstName[0]._", ""),
              "",
              _.get(node, "lastName[0]._", ""),
              this.props
            )}
          </Table.Cell>
        </Table.Row>
      );
      results.push(
        <Table.Row key={`Business_Record_Phone_Row_${this.props.index}`}>
          <Table.Cell>Phone:</Table.Cell>
          <Table.Cell>{_.get(node, "phone[0]._", "")}</Table.Cell>
          <Table.Cell>Employees:</Table.Cell>
          <Table.Cell>
            {_.get(node, "employeestotaldescription[0]._", "")}
          </Table.Cell>
        </Table.Row>
      );
      results.push(
        <Table.Row key={`Business_Record_Description_Row_${this.props.index}`}>
          <Table.Cell>Description:</Table.Cell>
          <Table.Cell>
            {`${_.get(node, "naics01description[0]._", "")} ${_.get(
              node,
              "naics02description[0]._",
              ""
            )} ${_.get(node, "naics03description[0]._", "")} ${_.get(
              node,
              "naics04description[0]._",
              ""
            )} ${_.get(node, "naics05description[0]._", "")}`}
          </Table.Cell>
          <Table.Cell>Revenue:</Table.Cell>
          <Table.Cell>
            {_.get(node, "Revenue[0]._", "")}{" "}
            {_.get(node, "salesvolumedescription[0]._", "")}
          </Table.Cell>
        </Table.Row>
      );
    }

    return (
      <Table>
        <Table.Body>{results}</Table.Body>
      </Table>
    );
  }
}

export default BusinessRecordDetail;



// WEBPACK FOOTER //
// ./src/components/searchresults/BusinessRecordDetail.js